<template>
    <FilterComponent :displayText="facet.title" ref="filter" class="radio-facet">
        <label class="noselect">
            <input type="radio" :value="null" v-model="boundModel" />
            <span></span>
            <span>{{ facet.selectAllText ?? 'Any' }}</span>
        </label>
        <label v-for="option in options" :key="option.display" class="noselect">
            <input type="radio" :value="option.value" v-model="boundModel" />
            <span></span>
            <span>{{ option.display }}</span>
        </label>
    </FilterComponent>
</template>
<script setup>
import FilterComponent from '../FilterComponent.vue'
import { computed } from 'vue'

const props = defineProps({
    facet: {
        type: Object,
        required: true,
    },
    criteria: {
        type: Array,
        default() {
            return []
        },
    },
})

const emit = defineEmits(['update:criteria'])

const options = computed(() => props.facet.values)
const boundModel = computed({
    get: () => {
        const name = props.facet.name

        return props.criteria.find(c => c.name === name)?.value ?? null
    },
    set: v => {
        const name = props.facet.name
        let criteria = props.criteria

        let criterion = options.value.find(o => o.value === v)

        if (!criterion) {
            emit(
                'update:criteria',
                criteria.filter(c => c.name !== name)
            )

            return
        }

        criterion = {
            display: criterion.display,
            name: props.facet.name,
            value: criterion.value,
        }

        const index = criteria.findIndex(c => c.name === name)

        if (index > -1) {
            criteria = criteria.slice(0)
            criteria.splice(index, 1, criterion)
        } else {
            criteria = [...criteria, criterion]
        }

        emit('update:criteria', criteria)
    },
})
</script>

<style scoped>
:deep(.filter-content) {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

label:first-child {
    border-bottom: 2px solid var(--color-primary-200);
    padding-bottom: 8px;
}

label {
    align-items: center;
    display: flex;
    flex-direction: row;
    gap: 8px;
}

input[type='radio'] {
    display: none;
}

input + span {
    display: inline-flex;
}

input + span:before {
    border-radius: 20px;
    color: var(--color-primary-600);
    content: 'radio_button_unchecked';
    font-family: 'Material Icons';
    font-weight: normal;
    font-style: normal;
    font-size: 24px;
    line-height: 1;
    letter-spacing: normal;
    text-transform: none;
    display: inline-block;
    white-space: nowrap;
    word-wrap: normal;
    direction: ltr;
    position: relative;
    visibility: visible;
}

input:checked + span:before {
    color: var(--color-secondary-500);
    content: 'radio_button_checked';
}
</style>
